import * as React from "react";
const Report = (props) => (
    <svg
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m13.515 9.248-.915-.915a1.04 1.04 0 0 1-.352-.773c-.015-.337.12-.675.367-.922l.9-.9c.78-.78 1.072-1.53.825-2.123-.24-.585-.982-.908-2.078-.908H4.426v-.644a.567.567 0 0 0-.562-.563.567.567 0 0 0-.563.563v13.875c0 .307.255.562.563.562a.567.567 0 0 0 .562-.562v-3.66h7.837c1.08 0 1.808-.33 2.056-.923.247-.593-.038-1.335-.803-2.107"
            fill="#687879"
        />
    </svg>
);
export default Report;
